module.exports = __webpack_public_path__ + "img/telephone_white2.cbc437e1.png";